<script lang="ts">
import {
    BiuOffer,
    MayWeSuggest
} from '@dotdash/proxima-shared/ui';
import {
    type IBIUOffer,
    type IMWSPromotion
} from '@dotdash/proxima-shared/types';
import { isObjectEmpty } from '@dotdash/proxima-shared/utils';
import {
    sendBiuTelemetry,
    sendMwsTelemetry
} from 'tracking/index.js';
import { validURL } from 'utils/index.js';
import { type IRmniConfig, type IPolParams } from 'interfaces/index.js';

export let isBiu: boolean = false;
export let isMws: boolean = false;
export let config: IRmniConfig;
export let polParams: IPolParams;
let displayOffer: any;

$: polParams;
$: {
    if (!isObjectEmpty(config)) {
        if (isBiu) {
            displayOffer = getBiuOffer(config);
        }
        if (isMws) {
            displayOffer = getMwsPromo(config);
        }
    }
}

function onBiuClickTelemetry(offer: IBIUOffer) {
    sendBiuTelemetry(offer);
    console.log('Biu offer clicked: ', offer);
}

function onMwsClickTelemetry(promo: IMWSPromotion) {
    sendMwsTelemetry(promo);
    console.log('MWS promo clicked: ', promo);
}

const getCta = (url: string): string => {
    if (!url) {
        return '';
    }
    
    const ctaUrl: URL = validURL(polParams.trackers.click)
        ? new URL(`${polParams.trackers.click}${url}`)
        : new URL(url);

    if (isObjectEmpty(polParams.trackers.params)) {
        return ctaUrl.toString();
    }

    for (const [key, value] of Object.entries(polParams.trackers.params)) {
        ctaUrl.searchParams.append(`${key}`, `${value}`);
    }

    return ctaUrl.toString();
}

const getBiuOffer = (config) => {
    return {
        ctaLink: `${getCta(config.defaultFooterBtnUrl)}`,
        ctaText: `${config.footerBtnLabel}`,
        heading: config.defaultProductName,
        id: config.baseItem.id,
        imageUrl: config.defaultProductImage,
        promotionPixels: [{}],
        subHeading: `${config.defaultProductPrice}`,
    } as unknown;
};

const getMwsPromo = (config) => {
    return {
        body: `${config.defaultProductPrice}`,
        ctaLink: `${getCta(config.defaultFooterBtnUrl)}`,
        ctaText: `<button style="color: white; background: rgb(255, 114, 25); padding: 10px; border: none; font-weight: 700; cursor: pointer;">${config.footerBtnLabel}</button>`,
        heading: config.defaultProductName,
        id: config.baseItem.id,
        imageUrl: config.defaultProductImage,
        promotionPixels: [{}],
    } as unknown;
}

const handleClick = (event) => {
    event.stopPropagation();

    if (isBiu) {
        onBiuClickTelemetry(displayOffer);
    }
    if (isMws) {
        onMwsClickTelemetry(displayOffer);
    }
}

</script>

<div class='display-ad'>
    {#if !window.pol_params}
        <p>
            Use of AdTag is required to render RMNI in production.
        </p>
        <p>
            <b>window.pol_params</b> not set. Tracking events will have empty values.
        </p>
    {/if}
    <!-- svelte-ignore a11y-missing-attribute -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <a href={`${getCta(config.defaultFooterBtnUrl)}`} on:click={handleClick} class="display-ad__link" target="_blank">
        {#if isBiu}
            <BiuOffer
                offer={displayOffer}
                isRmni={true}
            />
        {/if}
        {#if isMws}
            <MayWeSuggest
                promo={displayOffer}
                isRmni={true}
            />
        {/if}
    </a>
</div>

<style lang="scss">
    :global(body) {
        margin: 0;
        overflow: hidden;
        padding: 0;
    }

    .display-ad__link {
        cursor: pointer;
        text-decoration: none;
        color: black;

        :active,
        :hover,
        :visited {
            color: black;
        }
    }
</style>